import { Search } from "@mui/icons-material";
import {
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { FormikErrors, FormikTouched } from "formik";
import { inputError } from "src/grading/components/InputError/InputError";
import { Unit } from "src/store/reducers/organizations/organizationsApiSlice";
import { initialFilterValues } from "../Athletes";
import useStyles from "./AthleteFilters.styles";

interface AthleteFilterProps {
  values: typeof initialFilterValues;
  setFieldValue: (field: string, value: string) => void;
  debounceSearch: (searchValue: string) => void;
  filterSearch: (filter: {
    search?: string;
    unit?: string;
    status?: string;
    sortBy?: string;
  }) => void;
  errors: FormikErrors<typeof initialFilterValues>;
  touched: FormikTouched<typeof initialFilterValues>;
  units: Unit[];
}

const AthleteFilters = ({
  values,
  setFieldValue,
  debounceSearch,
  filterSearch,
  errors,
  touched,
  units,
}: AthleteFilterProps) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.filtersContainer}>
      <Grid container item sm={3} xs={12}>
        <TextField
          name="search"
          type="text"
          className={classes.searchField}
          inputProps={{
            className: classes.searchInputField,
          }}
          value={values.search}
          onChange={(e) => {
            setFieldValue("search", e.target.value);
            debounceSearch(e.target.value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
          placeholder="Search by user"
          error={inputError("search", touched, errors).error}
          helperText={inputError("search", touched, errors).helperText}
        />
      </Grid>

      <Grid className={classes.secondaryFiltersContainer} container flex={1}>
        <Grid
          item
          className={`${classes.selectInputContainer} ${classes.sortByInput}`}
          xs={12}
          sm={2}
        >
          <Select
            name="sortBy"
            value={values.sortBy}
            onChange={(e) => {
              setFieldValue("sortBy", e.target.value);
              filterSearch({
                search: values.search ? values.search : undefined,
                sortBy: e.target.value !== "-1" ? e.target.value : undefined,
              });
            }}
            className={classes.selectInput}
          >
            <MenuItem value={"-1"} disabled>
              Sort By
            </MenuItem>
            <MenuItem value="lastAppUse.desc">Most recent activity</MenuItem>
            <MenuItem value="lastAppUse.asc">Less recent activity</MenuItem>
          </Select>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AthleteFilters;
